export const getBalcony = ({
  loggiasCount,
  balconiesCount,
}: {
  loggiasCount?: number;
  balconiesCount?: number;
}): string => {
  return loggiasCount ? 'есть лоджия' : balconiesCount ? 'есть балкон' : 'нет балкона';
};
